const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardPaypal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 120,
    height: 80,
    rx: 4,
    ry: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.39,33.25h-5.53c-.38,0-.7,.28-.76,.65l-2.24,14.19c-.04,.28,.17,.53,.46,.53h2.64c.38,0,.7-.28,.76-.65l.6-3.83c.06-.37,.38-.65,.76-.65h1.75c3.65,0,5.75-1.76,6.3-5.26,.25-1.53,.01-2.73-.71-3.57-.79-.92-2.18-1.41-4.03-1.41Zm.64,5.18c-.3,1.99-1.82,1.99-3.29,1.99h-.84l.59-3.71c.03-.22,.23-.39,.46-.39h.38c1,0,1.94,0,2.43,.57,.29,.34,.38,.84,.27,1.54Z",
    style: {
      fill: "#253b80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,38.37h-2.65c-.23,0-.42,.17-.46,.39l-.12,.74-.19-.27c-.57-.83-1.85-1.11-3.13-1.11-2.93,0-5.43,2.22-5.92,5.33-.25,1.55,.11,3.04,.99,4.07,.81,.95,1.96,1.35,3.34,1.35,2.36,0,3.67-1.52,3.67-1.52l-.12,.74c-.04,.28,.17,.53,.45,.53h2.39c.38,0,.7-.28,.76-.65l1.43-9.07c.05-.28-.17-.53-.45-.53Zm-3.69,5.16c-.26,1.51-1.46,2.53-2.99,2.53-.77,0-1.38-.25-1.78-.71-.39-.46-.54-1.13-.42-1.86,.24-1.5,1.46-2.55,2.97-2.55,.75,0,1.36,.25,1.77,.72,.4,.48,.56,1.14,.45,1.87Z",
    style: {
      fill: "#253b80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05,38.37h-2.66c-.25,0-.49,.13-.64,.34l-3.67,5.41-1.56-5.2c-.1-.33-.4-.55-.74-.55h-2.62c-.32,0-.54,.31-.44,.61l2.93,8.61-2.76,3.89c-.22,.31,0,.73,.38,.73h2.66c.25,0,.49-.12,.63-.33l8.86-12.78c.21-.31,0-.72-.38-.72Z",
    style: {
      fill: "#253b80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.86,33.25h-5.53c-.38,0-.7,.28-.76,.65l-2.24,14.19c-.04,.28,.17,.53,.45,.53h2.84c.26,0,.49-.19,.53-.45l.64-4.02c.06-.37,.38-.65,.76-.65h1.75c3.65,0,5.75-1.76,6.3-5.26,.25-1.53,0-2.73-.71-3.57-.79-.92-2.18-1.41-4.03-1.41Zm.64,5.18c-.3,1.99-1.82,1.99-3.29,1.99h-.83l.59-3.71c.03-.22,.23-.39,.45-.39h.38c1,0,1.94,0,2.43,.57,.29,.34,.38,.84,.27,1.54Z",
    style: {
      fill: "#179bd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,38.37h-2.65c-.23,0-.42,.17-.45,.39l-.12,.74-.19-.27c-.57-.83-1.85-1.11-3.13-1.11-2.93,0-5.43,2.22-5.92,5.33-.25,1.55,.11,3.04,.99,4.07,.81,.95,1.96,1.35,3.34,1.35,2.36,0,3.67-1.52,3.67-1.52l-.12,.74c-.04,.28,.17,.53,.46,.53h2.39c.38,0,.7-.28,.76-.65l1.43-9.07c.04-.28-.17-.53-.46-.53Zm-3.69,5.16c-.25,1.51-1.46,2.53-2.99,2.53-.77,0-1.38-.25-1.78-.71-.39-.46-.54-1.13-.42-1.86,.24-1.5,1.46-2.55,2.97-2.55,.75,0,1.36,.25,1.77,.72,.41,.48,.57,1.14,.45,1.87Z",
    style: {
      fill: "#179bd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.53,33.64l-2.27,14.45c-.04,.28,.17,.53,.45,.53h2.28c.38,0,.7-.28,.76-.65l2.24-14.19c.04-.28-.17-.53-.45-.53h-2.56c-.23,0-.42,.17-.45,.39Z",
    style: {
      fill: "#179bd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.88,51.38l.42-2.69-.94-.02h-4.5l3.13-19.83c0-.06,.04-.12,.09-.16,.05-.04,.11-.06,.17-.06h7.59c2.52,0,4.26,.52,5.17,1.56,.43,.49,.7,.99,.83,1.55,.14,.59,.14,1.29,0,2.14v.06s0,.55,0,.55l.43,.24c.36,.19,.64,.41,.86,.66,.36,.42,.6,.94,.7,1.57,.1,.64,.07,1.41-.1,2.28-.19,1-.51,1.87-.93,2.58-.39,.65-.89,1.2-1.48,1.62-.56,.4-1.23,.7-1.99,.9-.73,.19-1.57,.29-2.49,.29h-.59c-.42,0-.83,.15-1.15,.42-.32,.28-.54,.66-.6,1.07l-.04,.24-.75,4.74-.03,.17c0,.06-.02,.08-.05,.1-.02,.02-.05,.03-.08,.03h-3.65Z",
    style: {
      fill: "#253b80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.65,33.99h0c-.02,.14-.05,.29-.08,.45-1,5.14-4.43,6.91-8.8,6.91h-2.23c-.53,0-.99,.39-1.07,.92h0l-1.14,7.23-.32,2.05c-.05,.35,.21,.66,.56,.66h3.95c.47,0,.86-.34,.94-.8l.04-.2,.74-4.72,.05-.26c.07-.46,.47-.8,.94-.8h.59c3.83,0,6.82-1.55,7.7-6.05,.37-1.88,.18-3.45-.79-4.55-.29-.33-.66-.61-1.08-.83Z",
    style: {
      fill: "#179bd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,33.58c-.15-.04-.31-.08-.47-.12-.16-.04-.33-.07-.5-.09-.6-.1-1.26-.14-1.96-.14h-5.95c-.15,0-.29,.03-.41,.09-.27,.13-.48,.39-.53,.71l-1.27,8.02-.04,.23c.08-.53,.53-.92,1.07-.92h2.23c4.37,0,7.8-1.78,8.8-6.91,.03-.15,.06-.3,.08-.45-.25-.13-.53-.25-.82-.35-.07-.02-.15-.05-.22-.07Z",
    style: {
      fill: "#222d65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78,34.02c.05-.32,.25-.58,.53-.71,.13-.06,.26-.09,.41-.09h5.95c.7,0,1.36,.05,1.96,.14,.17,.03,.34,.06,.5,.09,.16,.04,.32,.08,.47,.12,.08,.02,.15,.05,.22,.07,.3,.1,.57,.21,.82,.35,.3-1.9,0-3.19-1.03-4.36-1.13-1.29-3.18-1.84-5.79-1.84h-7.59c-.53,0-.99,.39-1.07,.92l-3.16,20.04c-.06,.4,.24,.75,.64,.75h4.69l1.18-7.46,1.27-8.02Z",
    style: {
      fill: "#253b80"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPaypal);
export default __webpack_public_path__ + "static/media/card_paypal.02dc8aa12d4992560a09a975bdc38b49.svg";
export { ForwardRef as ReactComponent };